import dynamic from 'next/dynamic'
import { ReactNode, useRef } from 'react'
import AnimateHeight from 'react-animate-height'

import styles from '../search.module.scss'
import { Size } from '@/types/system'
import { filterClassName } from '@/lib/utilities/search'
import { isProd } from '@/lib/utilities/system'

const Icon = dynamic(() => import('@/components/styleguide/Icon'))

type FilterDropdownProps = {
  children: ReactNode
  title: string
  isFilterOpen: boolean
  isFilterDisabled?: boolean
  hasSelectedOptions: boolean
  toggleFilter: () => void
  selectedOptions?: string[] | ['All'] | undefined
  maximumNumberOfVisibleSelectedOptions?: number
  hasSpacingBottom?: boolean
}

export const FilterDropdown = ({
  title,
  children,
  isFilterOpen = false,
  isFilterDisabled = false,
  hasSelectedOptions = false,
  toggleFilter,
  selectedOptions = ['All'],
  maximumNumberOfVisibleSelectedOptions = 3,
  hasSpacingBottom = true,
}: FilterDropdownProps) => {
  const selectedOptionsRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={styles.filter}
      data-has-spacing-bottom={hasSpacingBottom}
      data-is-open={isFilterOpen}>
      <button
        className={`${styles.header}${!isProd() ? ` search__dropdown-button search__dropdown-button-${filterClassName(title)}` : ''}`}
        type="button"
        disabled={isFilterDisabled}
        onClick={toggleFilter}>
        <span className={styles.text}>
          <span className={styles.name}>{title}</span>
          <span
            className={styles.selected}
            data-has-selections={hasSelectedOptions}
            ref={selectedOptionsRef}>
            {selectedOptions.slice(0, maximumNumberOfVisibleSelectedOptions).join(', ')}
            {maximumNumberOfVisibleSelectedOptions < selectedOptions.length
              ? ` + ${selectedOptions.length - maximumNumberOfVisibleSelectedOptions}`
              : ''}
          </span>
        </span>
        <Icon
          customClass={styles.chevron}
          name="ChevronDown"
          size={Size.Large}
        />
      </button>
      <AnimateHeight height={isFilterOpen ? 'auto' : 0}>{children}</AnimateHeight>
    </div>
  )
}
